import { makeStyles } from '@material-ui/core/styles';
import { CardProps } from './types';

const useStyles = makeStyles({
  root: {
    width: (props: CardProps) => props.width,
    height: (props: CardProps) => props.height,
    position: 'relative',
    borderRadius: '4px',
    boxShadow: `0 1px 4px 0 rgba(69, 69, 69, 0.2),
      0 1px 2px 0 rgba(69, 69, 69, 0.1)`
  }
});

export default useStyles;
